import styles from './delete-place-dialog.module.scss';
import { makeCourseRequest, useCourseGetRequestHook } from '../../../../requestUtils';
import { useContext, useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, LoadingButton, SnackBarContext, Typography } from '@frontend-workspace/react-shared-lib';
import { IRoom } from '../../../../_models/room';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface DeletePlaceDialogProps {
  onClose: () => void,
  open: boolean,
  refreshData: () => void,
  roomId: string
}

export function DeletePlaceDialog(props: DeletePlaceDialogProps) {
  const { data: room }: { data: IRoom } = useCourseGetRequestHook(`room/get/${props.roomId}`, undefined);

  const { t } = useTranslation();
  const { setSnackbarMessage } = useContext(SnackBarContext);
  const [loading, setLoading] = useState<boolean>(false);

  const handleDeletePlace = () => {
    setLoading(true);
    makeCourseRequest(`room/delete/${props.roomId}`, 'DELETE').then(result => {
      setSnackbarMessage({ content: t('deletePlace.deletedPlaceFromList'), type: "success" });
      setLoading(false);
      props.refreshData();
      props.onClose();
    }).catch(() => setSnackbarMessage({ content: t('deletePlace.couldNotDeleteLocationFromList'), type: "error" }));
  };

  return (
    <Dialog
      open={props.open}
      maxWidth="sm"
      fullWidth>
      <DialogTitle className='mb-4'>
        {t('deletePlace.areYouSureYouWantToDeleteLocation')}
      </DialogTitle>
      <DialogContent>
        <Typography
          component="div"
          variant='subtitle3'
          className='mb-3'>
          {room?.name}
        </Typography>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          variant="contained"
          size='large'
          color='error'
          onClick={handleDeletePlace}
          disabled={loading}
          loading={loading}
          className='minButtonWidth'>
          {loading ? '' : t('standard.delete')}
        </LoadingButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t('standard.cancel')}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default DeletePlaceDialog;
